export const FilterBar = ({ filters, values = {}, onChange }) => (
  <div className="bg-gray-50 rounded-lg p-6 mb-6">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {filters.map((filter) => (
        <div key={filter.name} className="flex items-center gap-2">
          <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
            {filter.label}:
          </label>
          <select
            className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={values[filter.name] || 'all'}
            onChange={(e) => onChange(filter.name, e.target.value)}
          >
            {filter.options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  </div>
);